import { faker } from '@faker-js/faker';
import type { PricingTableColumn } from '../pricing-table';
import { PricingTableColumn as EPricingTableColumn } from '../enums/pricing-table';
import type { PricingTable } from '../models';
import { NodeType } from '../enums';

const pricingTableMock: Required<PricingTable> = {
  id: 'DNJeVVHr_rOvlA2bGAekK',
  type: NodeType.PricingTable,
  externalId: '',
  content: null,
  name: null,
  preCalculated: false,
  locked: false,
  displayName: '',
  pricingTableSections: [
    {
      id: '59UEDkh-QPznCO28J0UrX',
      displayName: 'Pricing Table Group 1',
      columns: [
        {
          id: 'mRbotCLUwA8kuzBg6eMCa',
          name: 'name',
          displayName: 'Name',
          width: 15.9,
          enabled: true,
          isCustom: null,
          type: null,
          unit: null,
          productPropertyId: null,
        },
        {
          id: 'mx8UmycHAxWZ0utL5Zxfx',
          name: 'description',
          displayName: 'Description',
          width: 0,
          enabled: true,
          isCustom: null,
          type: null,
          unit: null,
          productPropertyId: null,
        },
        {
          id: 'kqBxnaKsRma7uEKD-8DzB',
          name: 'sku',
          displayName: 'SKU',
          width: 0,
          enabled: true,
          isCustom: null,
          type: null,
          unit: null,
          productPropertyId: null,
        },
        {
          id: 'l_MqjPoQhlTm282LCsPpo',
          name: 'price',
          displayName: 'Price',
          width: 19.2,
          enabled: true,
          isCustom: null,
          type: null,
          unit: null,
          productPropertyId: null,
        },
        {
          id: '_ekaThLaBnRsl2Sjh7jbp',
          name: 'tax',
          displayName: 'Tax',
          width: 22.62,
          enabled: true,
          isCustom: null,
          type: null,
          unit: null,
          productPropertyId: null,
        },
        {
          id: 'BevCuo1OcL5Qtw8kK1RdL',
          name: 'customColumn1',
          displayName: 'Custom column',
          width: 18.15,
          enabled: true,
          isCustom: true,
          type: null,
          unit: null,
          productPropertyId: null,
        },
        {
          id: 'FjN1iH-vPqPqEBQoKuBbJ',
          name: 'units',
          displayName: 'Units',
          width: 11.47,
          enabled: true,
          isCustom: null,
          type: null,
          unit: null,
          productPropertyId: null,
        },
        {
          id: 'EY3Qak2VNTQFpYsC_W_0n',
          name: 'discount',
          displayName: 'Discount',
          width: 0,
          enabled: false,
          isCustom: null,
          type: null,
          unit: null,
          productPropertyId: null,
        },
        {
          id: 'TDoMg8uh_VHgtDMAx1qFC',
          name: 'netPrice',
          displayName: 'Net price',
          width: 0,
          enabled: true,
          isCustom: null,
          type: null,
          unit: null,
          productPropertyId: null,
        },
        {
          id: 'tJ4wo3TWgxIOK9jZl9F4Q',
          name: 'totalPrice',
          displayName: 'Total price',
          width: 12.66,
          enabled: true,
          isCustom: null,
          type: null,
          unit: null,
          productPropertyId: null,
        },
      ],
      rows: [
        {
          id: 'U518Tjr5-m2-aevYmp7NW',
          values: [
            {
              columnId: 'mRbotCLUwA8kuzBg6eMCa',
              value: 'Test row 1',
            },
            {
              columnId: 'mx8UmycHAxWZ0utL5Zxfx',
              value: '',
            },
            {
              columnId: 'kqBxnaKsRma7uEKD-8DzB',
              value: '',
            },
            {
              columnId: 'l_MqjPoQhlTm282LCsPpo',
              value: '10',
            },
            {
              columnId: '_ekaThLaBnRsl2Sjh7jbp',
              value: '1',
            },
            {
              columnId: 'BevCuo1OcL5Qtw8kK1RdL',
              value: 'Custom column input',
            },
            {
              columnId: 'FjN1iH-vPqPqEBQoKuBbJ',
              value: '1',
            },
            {
              columnId: 'EY3Qak2VNTQFpYsC_W_0n',
              value: '',
            },
            {
              columnId: 'TDoMg8uh_VHgtDMAx1qFC',
              value: '',
            },
            {
              columnId: 'tJ4wo3TWgxIOK9jZl9F4Q',
              value: '',
            },
          ],
          discountFlatFee: null,
          taxFlatFee: null,
          optionalProductFieldId: '',
          variableQuantityFieldId: '',
        },
      ],
      sectionSummary: {
        discount: {
          value: '',
          enabled: true,
          flatFee: false,
          displayName: 'Discount',
        },
        tax: {
          value: '',
          enabled: true,
          flatFee: false,
          displayName: 'Tax',
        },
        price: {
          value: '',
          enabled: true,
          flatFee: false,
          displayName: 'Total amount',
        },
        extendedSummaries: [],
      },
    },
  ],
  pricingTableSummaryValues: {
    displayName: 'Pricing summary',
    discount: {
      value: '',
      enabled: false,
      flatFee: false,
      displayName: 'Discount',
    },
    tax: {
      value: '',
      enabled: false,
      flatFee: false,
      displayName: 'Tax',
    },
    price: {
      value: '',
      enabled: true,
      flatFee: false,
      displayName: 'Total',
    },
    baseSubtotal: {
      value: '',
      enabled: true,
      displayName: 'baseSubtotal',
    },
    taxBreakdown: {
      enabled: false,
      value: '',
      displayName: '',
      rates: [],
    },
    combinedSubtotal: {
      value: '',
      enabled: true,
      displayName: 'combinedSubtotal',
    },
  },
  currencySettings: {
    formatOptions: {
      currency: 'SEK',
      currencyDisplay: 'symbol',
    },
    locale: 'sv-SE',
  },
  fields: null,
};

export class PricingTableMock {
  static oneColumn(payload?: Partial<PricingTableColumn>): PricingTableColumn {
    return {
      id: faker.string.uuid(),
      name: EPricingTableColumn.Name,
      displayName: faker.lorem.words(1),
      enabled: true,
      width: faker.number.int({ min: 10, max: 100 }),
      productPropertyId: null,
      isCustom: false,
      ...payload,
    };
  }
  static manyColumns(length = 2, payload?: Partial<PricingTableColumn>): PricingTableColumn[] {
    return Array.from({ length }).map(() => this.oneColumn(payload));
  }
  static onePricingTable(payload?: Partial<PricingTable>): PricingTable {
    return { ...structuredClone(pricingTableMock), ...payload };
  }
}
